import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDuplicate = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 4H13.3889C14.1869 4 14.8333 4.59667 14.8333 5.33333V14H15.5556C16.3536 14 17 13.4033 17 12.6667V3.33333C17 2.59667 16.3536 2 15.5556 2H5.44444C4.64639 2 4 2.59667 4 3.33333V4ZM12.6667 5H3.33333C2.59667 5 2 5.63176 2 6.41176V15.5882C2 16.3682 2.59667 17 3.33333 17H12.6667C13.4033 17 14 16.3682 14 15.5882V6.41176C14 5.63176 13.4033 5 12.6667 5ZM8.61538 7.61538C8.61538 7.275 8.34038 7 8 7C7.65962 7 7.38462 7.275 7.38462 7.61538V10.3846H4.61538C4.275 10.3846 4 10.6596 4 11C4 11.3404 4.275 11.6154 4.61538 11.6154H7.38462V14.3846C7.38462 14.725 7.65962 15 8 15C8.34038 15 8.61538 14.725 8.61538 14.3846V11.6154H11.3846C11.725 11.6154 12 11.3404 12 11C12 10.6596 11.725 10.3846 11.3846 10.3846H8.61538V7.61538Z",
		fillRule: "evenodd",
		clipRule: "evenodd",
		fill: "#0D2976"
	})
});
export default SvgDuplicate;
